import React from 'react';
import PropTypes from 'prop-types';
import Facet from '../../../components/react/Facet';

const GiftCardSearchElement = ({
  headerTitle,
  headerCopy,
  searchInputLabel,
  searchInputPlaceholder,
  searchInputSubmit,
  filtersLabel,
  filtersClearLabel,
  linksTitle,
  links,
  searchQuery,
  setSearchQuery,
  facets,
  handleFacetChange,
  handleFacetClear,
  handleFormSubmit
}) => {
  const submitForm = e => {
    e.preventDefault();
    handleFormSubmit();
  };

  const displayLinksBox = links && links.length > 0;

  return (
    <div className="gift-card-search-element">
      <div className="container gift-card-search-element__inner">
        <div
          className={`gift-card-search-element__filter-box ${
            !displayLinksBox ? 'full-width' : ''
          }`}
        >
          <h1 className="gift-card-search-element__title">{headerTitle}</h1>
          <p
            className="gift-card-search-element__copy"
            dangerouslySetInnerHTML={{ __html: headerCopy }}
          />
          <div className="gift-card-search-element__filters-container">
            <form
              className="gift-card-search-element__form-group"
              onSubmit={submitForm}
            >
              <div className="form-group">
                <label className="form-label" htmlFor="gift-search-input">
                  {searchInputLabel}
                </label>
                <div className="form-input form-input--placeholder">
                  <input
                    placeholder={searchInputPlaceholder}
                    value={searchQuery}
                    onChange={({ target: { value } }) => setSearchQuery(value)}
                    id="gift-search-input"
                  />
                  <button type="submit" className="btn btn--primary">
                    {searchInputSubmit}
                  </button>
                </div>
              </div>
            </form>
            <div className="form-group">
              <label className="form-label">{filtersLabel}</label>
              {facets.map(facet => (
                <Facet
                  key={facet.name}
                  {...facet}
                  parentLabel={filtersLabel}
                  onChange={handleFacetChange}
                  onClear={() => handleFacetClear(facet.name)}
                  clearLabel={filtersClearLabel}
                />
              ))}
            </div>
          </div>
        </div>
        {displayLinksBox && (
          <div className="gift-card-search-element__links-box">
            <h2>{linksTitle}</h2>
            <div>
              {links.map(({ link, label, newWindow }) => (
                <a
                  href={link}
                  key={link}
                  target={newWindow ? '_blank' : '_self'}
                  className="link link--small link--light link--animated"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

GiftCardSearchElement.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerCopy: PropTypes.string.isRequired,
  searchInputLabel: PropTypes.string.isRequired,
  searchInputPlaceholder: PropTypes.string.isRequired,
  searchInputSubmit: PropTypes.string.isRequired,
  filtersLabel: PropTypes.string.isRequired,
  filtersClearLabel: PropTypes.string.isRequired,
  linksTitle: PropTypes.string.isRequired,
  links: PropTypes.array,
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  facets: PropTypes.array.isRequired,
  handleFacetChange: PropTypes.func.isRequired,
  handleFacetClear: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired
};

export default GiftCardSearchElement;
